import TabPanel from "@/components/tabs/TabPanel";
import TabsStyled from "@/components/tabs/TabsStyled";
import {
  searchResultCountState,
  searchResultPagesState,
  searchResultSongsState,
  searchViewState,
} from "@/context/states";
import { createFilterConfig, getPlayerPlaylist } from "@/lib/api";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import BandListPage from "./BandListPage";
import MusikSuchenResultBands from "./MusikSuchenResultBands";
import MusikSuchenResultPlaylists from "./MusikSuchenResultPlaylists";
import MusikSuchenResultSongs from "./MusikSuchenResultSongs";
import PlaylistListPage from "./PlaylistListPage";

const HEADERS = ["Songs", "Bands", "Playlisten"];

export const MusikSuchenResults = ({ searchConfig }) => {
  const searchResultCount = useRecoilValue(searchResultCountState);
  const [searchResults, setSearchResults] = useRecoilState(
    searchResultPagesState,
  );
  const [searchResultSongs, setSearchResultSongs] = useRecoilState(
    searchResultSongsState,
  );
  const [searchView, setSearchView] = useRecoilState(searchViewState);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [urlPlaylist, setUrlPlaylist] = useState("");
  const [filterName, setFilterName] = useState("Meine Playlist");
  const [embeddablePlaylist, setEmbeddablePlaylist] = useState(null);

  const handleModalClosed = () => setIsModalOpen(false);

  useEffect(() => {
    if (searchConfig) {
      setSearchResultSongs([]);

      const songs = [];
      const bands = [];
      const playlists = [];
      //songs.push(<SongListPage searchConfig={searchConfig} page={0} />);
      bands.push(<BandListPage searchConfig={searchConfig} page={0} />);
      playlists.push(<PlaylistListPage searchConfig={searchConfig} page={0} />);

      setSearchResults({ songs, bands, playlists });
    }
  }, [searchConfig]);

  const handleShareList = async () => {
    let title = filterName || "Meine Playlist";

    if (
      searchConfig.region?.name &&
      (title.length === 0 ||
        title.indexOf("Sound of") === 0 ||
        title === "Meine Playlist")
    ) {
      title = `Sound of ${searchConfig.region.name}`;
      setFilterName(title);
    }

    const config = { config: JSON.stringify(searchConfig), title };

    const result = await createFilterConfig(config);
    const u = `${location.protocol}//${location.host}/musik/suchen?filterId=${result.createFilterConfig.filterConfig.id}`;

    setUrlPlaylist(u);
    getPlayerPlaylist("filter", result.createFilterConfig.filterConfig.id).then(
      (playlist) => {
        setEmbeddablePlaylist(playlist);
        setIsModalOpen(true);
      },
    );
  };

  const handleTabChanged = (index) => {
    setSearchView(index);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid item xs={12}>
          <TabsStyled headers={HEADERS} onTabChanged={handleTabChanged}>
            <TabPanel index={0} value={searchView}>
              <MusikSuchenResultSongs
                searchConfig={searchConfig}
                playlist={embeddablePlaylist}
                urlPlaylist={urlPlaylist}
                onShareModelOpened={handleShareList}
                isModalOpen={isModalOpen}
                onModalClosed={handleModalClosed}
              />
            </TabPanel>

            <TabPanel index={1} value={searchView}>
              <MusikSuchenResultBands searchConfig={searchConfig} />
            </TabPanel>

            <TabPanel index={2} value={searchView}>
              <MusikSuchenResultPlaylists searchConfig={searchConfig} />
            </TabPanel>
          </TabsStyled>
        </Grid>
      </Grid>
    </Grid>
  );
};
